/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S11_Resend_LabelInputs */

const tr_mesafeli_s11_resend_label = /** @type {(inputs: Mesafeli_S11_Resend_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend Inc. (ABD):`)
};

const en_mesafeli_s11_resend_label = /** @type {(inputs: Mesafeli_S11_Resend_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend Inc. (USA):`)
};

const de_mesafeli_s11_resend_label = /** @type {(inputs: Mesafeli_S11_Resend_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend Inc. (USA):`)
};

const ru_mesafeli_s11_resend_label = /** @type {(inputs: Mesafeli_S11_Resend_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend Inc. (США):`)
};

/**
* | output |
* | --- |
* | "Resend Inc. (USA):" |
*
* @param {Mesafeli_S11_Resend_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s11_resend_label = /** @type {((inputs?: Mesafeli_S11_Resend_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S11_Resend_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s11_resend_label(inputs)
	if (locale === "de") return de_mesafeli_s11_resend_label(inputs)
	if (locale === "ru") return ru_mesafeli_s11_resend_label(inputs)
	return tr_mesafeli_s11_resend_label(inputs)
});